export default (params) => ({
  trigger: {
    name: 'insurance_selector.click_explanation_icon',
    params: params,
  },
  config: {
    schema: {
      subject_id: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'employee_atc_page',
          'employee_ato_page',
          'customer_atc_page',
          'insurance_information_overlay',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'read_explanation',
      params: {
        subject_type: 'item',
      },
    },
    nonInt: true,
  },
});
